import React from 'react'


export const Searched = () => {




  return (

    <div className='contaciner'>
      <div className='col-sm-4 col-md-4 m-auto text-center p-3'>
        
      </div>
      
    </div>
  )
}
